import { Component } from '@theme/component';

class RareBreedProduct extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.abort = new AbortController();
    this.image = this.querySelector('[data-main-image] img');
    this.original = this.image?.cloneNode(true);
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.resetGallery();
    }, { signal: this.abort.signal });
  }
  showMedia(event) {
    const button = event.target.closest('[data-gallery-button]');
    const thumbnail = button?.querySelector('img');
    if (!thumbnail || !this.image) return;
    const next = thumbnail.cloneNode(true);
    next.removeAttribute('width');
    next.removeAttribute('height');
    next.loading = 'eager';
    if (this.original?.sizes) next.sizes = this.original.sizes;
    this.image.replaceWith(next);
    this.image = next;
    this.querySelectorAll('[data-gallery-button]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    this.querySelector('[data-gallery-status]').textContent = next.alt;
  }
  resetGallery() {
    if (!this.original || !this.image) return;
    const next = this.original.cloneNode(true);
    this.image.replaceWith(next);
    this.image = next;
    this.querySelectorAll('[data-gallery-button]').forEach(item => item.setAttribute('aria-pressed', String(item.hasAttribute('data-primary-photo'))));
    this.querySelector('[data-gallery-status]').textContent = next.alt;
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.abort?.abort();
  }
}

if (!customElements.get('rb-product')) customElements.define('rb-product', RareBreedProduct);
